import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Login from "./components/Pages/Login";
import ManualPage from "./components/Pages/ManualPage";
import PasswordChange from "./components/Layouts/PasswordChange";
import OutboundNoticeManagement from "./components/Pages/OutboundNoticeManagement";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./routes/PrivateRoute";
import KakaoFriendsTest from "./components/Pages/KakaoFriendsTest";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={ <Login />} />
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <App />
              </PrivateRoute>
            }
          />
          <Route
            path="/outboundNoticeManagement"
            element={
              <PrivateRoute>
                <OutboundNoticeManagement />
              </PrivateRoute>
            }
          />
          <Route path="/manual" element={
              <ManualPage />
          } />
          <Route path="/passwordChange" element={<PasswordChange />} />
          <Route path="*" element={<Login />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
